import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between w-100" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "text-body-2" }

import { computed, ref, inject, watch } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useGuestsCount } from '@/app/composables/useGuestsCount'
import GuestsCounter from './GuestsCounter.vue'
import GuestsActionsToolbar from './GuestsActionsToolbar.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'GuestsSelector',
  props: {
  roomStayIndex: {
    type: Number,
    required: true
  },
  roomStay: {
    type: Object,
    required: true
  },
  guests: {
    type: Object,
    required: true
  }
},
  emits: ['change', 'clear', 'remove', 'dropdown'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const emitter = inject('emitter')
const { guestsCountString } = useGuestsCount()

const props = __props

const emit = __emit

const store = useStore()
const menuOpen = ref(false)
const route = useRoute()

watch(menuOpen, (newValue) => {
  if (!newValue) {
    emitter.emit('dropdown', false)
  }
})

const bookingRequest = computed(() => store.getters.bookingRequest)

const handleApply = () => {
  menuOpen.value = false
  emitter.emit('dropdown', false)
}

const guestsCompiledString = computed(() => {
  const { adults, children, infants } = props.guests
  return route.name === 'package'
    ? guestsCountString(props.roomStay[adults?.id])
    : guestsCountString(
        props.roomStay[adults?.id],
        props.roomStay[children?.id],
        props.roomStay[infants?.id]
      )
})

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_menu, {
      modelValue: menuOpen.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((menuOpen).value = $event)),
      "close-on-content-click": false,
      transition: "slide-y-transition"
    }, {
      activator: _withCtx(({ props }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_fa_icon, {
              class: "mr-2",
              icon: ['far', 'user']
            }),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('Search#Form#Field#NumGuests Guests')), 1)
          ]),
          (bookingRequest.value.rooms > 1)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "pa-0",
                slim: "",
                variant: "text",
                "min-width": 25,
                height: 25,
                ripple: false,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('remove', __props.roomStayIndex)), ["stop","prevent"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_fa_icon, {
                    class: "text-body-1",
                    icon: ['fas', 'xmark']
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_btn, _mergeProps(props, {
          class: "text-none mt-2 text-body-2 pl-4 text-left justify-start overflow-hidden",
          style: {"--v-btn-height":"40px"},
          disabled: __props.roomStay.isBooked,
          ripple: false,
          size: "large",
          block: "",
          variant: "outlined"
        }), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(guestsCompiledString.value) + " ", 1),
            _createVNode(_component_v_icon, {
              icon: menuOpen.value ? 'mdi-menu-up' : 'mdi-menu-down',
              class: "position-absolute right-0 mr-4"
            }, null, 8, ["icon"])
          ]),
          _: 2
        }, 1040, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "pa-4 mt-2 ml-n4",
          "min-width": "300"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.guests, (item) => {
              return (_openBlock(), _createBlock(GuestsCounter, {
                key: item.id,
                item: item,
                "model-value": __props.roomStay,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', $event)))
              }, null, 8, ["item", "model-value"]))
            }), 128)),
            _createVNode(GuestsActionsToolbar, {
              onClear: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('clear', __props.roomStayIndex))),
              onApply: handleApply
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})